import { useAuth0 } from '@auth0/auth0-react';

export default function Callback() {
  const { isAuthenticated, isLoading, error } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (error) {
    const message = error.message.toLowerCase();
    const reason = message.includes('consent')
      ? 'Permission was declined. You can try connecting again when you are ready.'
      : message.includes('expired')
        ? 'This connection session expired before it finished.'
        : 'The connection could not be completed. Your account is still safe.';
    return (
      <div className="flex items-center justify-center min-h-screen flex-col gap-2">
        <div className="max-w-md text-center text-red-600">{reason}</div>
        <button
          onClick={() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/login';
          }}
          className="text-brand-cobalt underline"
        >
          Try connecting again
        </button>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500">Redirecting...</div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen flex-col gap-2">
      <div className="text-gray-500">Not authenticated</div>
      <button
        onClick={() => {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = '/login';
        }}
        className="text-brand-cobalt underline"
      >
        Go to login
      </button>
    </div>
  );
}
